import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header';
import { Button, Col, Dropdown, Form, Modal, Row, Spinner } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const KioskOutletUsers = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login); 
    const { email } = useSelector((state) => state.login);
    const [outletAccess, setOutletAccess] = useState([]);

    console.log("Access :", access);
    console.log("Email :", email);


    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
              perm?.startsWith("KioskUser:")
            );
            setOutletAccess(filteredAccess);
        }
    }, [access]);

    console.log("Outlet Access:", outletAccess);

    const accessToken = localStorage.getItem('authToken');
    const [outletUserList, setOutletUserList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [kioskUserId, setKioskUserId] = useState('');
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [userInputData, setUserInputData] = useState({
        name: "",
        signupType: "",
        mobile: "",
        email: "",
        outlet: "",
        password: ""
    });
    const [editedUserData, setEditedUserData] = useState({});
    const [errors, setErrors] = useState({});
    const [editErrors, setEditErrors] = useState({});
    const [outletsList, setOutletsList] = useState([]);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const columns = [
        { header: "Sr.No", accessor: "serialNumber" },
        {
            header: "User Name",
            accessor: "name",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0">{value}</h6>
                    <span className="fs-xs text-secondary">{row.email}</span>
                </div>
            ),
        },
        { header: "Contact", accessor: "mobile",
            render: (value, row) => (
                <div>
                    <span className='text-primary'>{value}</span>
                </div>
            )
        },
        {
            header: "Outlet",
            accessor: "idNumber",
            render: (value, row) => (
                <div>
                    <span className="mb-0">{row?.outlet?.name}</span>
                </div>
            ),
        },
        
        {
            header: "Sign Up Type",
            accessor: "role",
            render: (value, row) => (
                <div>
                    <span className="mb-0">{row?.signupType}</span>
                </div>
            ),
        },
        {
            header: "Actions",
            accessor: null,
            render: (_, row) => (
                <div className="d-flex justify-content-center">
                <Dropdown>
                    <Dropdown.Toggle variant="link" className="p-0 m-0 border-0">
                    <i className="ri-more-2-fill" style={{ cursor: "pointer" }}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                        {(outletAccess.includes("KioskUser:update") || email === 'contact@xpansecafe.com') && (
                            <Dropdown.Item
                                className="text-primary"
                                onClick={() => handleEditModal(row)}
                            >
                                Edit
                            </Dropdown.Item>
                        )}
                        {(outletAccess?.includes("KioskUser:get") || email === 'contact@xpansecafe.com') && (
                            <Dropdown.Item
                                className="text-success"
                                // onClick={() => handleOpenViewModal(row)}
                            >
                                View
                            </Dropdown.Item>
                        )}
                        {(outletAccess?.includes("KioskUser:delete") || email === 'contact@xpansecafe.com') && (
                            <Dropdown.Item
                                className="text-danger"
                                onClick={() => handleDeleteModal(row)}
                            >
                                Delete
                            </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </Dropdown>
                </div>
            ),
        },
    ];

    const getKioskOultetUsers = async() => {
        setDataLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get('user/kiosk-outlet-user', { headers });
            response?.data?.data?.kioskOutletUsers?.forEach((item, index) => {
                item.serialNumber = index + 1;
            })
            setOutletUserList(response?.data?.data?.kioskOutletUsers);
            setFilteredData(response?.data?.data?.kioskOutletUsers);
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
                });
            }
        } finally {
            setDataLoading(false);
        }
    };

    const getOutletsData = async() => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get("outlet", { headers });
            setOutletsList(response?.data?.data?.outlets);
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
                });
            }
        }
    }

    const validateForm = () => {
        const newErrors = {};
        const trimmedTitle = userInputData?.name.trim();
        const wordCount = trimmedTitle.split(/\s+/).length;
        const specialCharacterPattern = /[!@#$%^&*(),.?":{}|<>]/;
    
        // Validate name
        if (!userInputData?.name) {
            newErrors.name = "Name is required";
        } else if (!isNaN(userInputData?.name) || /^-\d+$/.test(userInputData?.name)) {
            newErrors.name = "Name should not contain numeric or a negative integer";
        } else if (trimmedTitle.length < 2) {
            newErrors.name = "Name must contain at least 2 letters";
        } else if (specialCharacterPattern.test(userInputData?.name)) {
            newErrors.name = "Name should not contain special characters";
        }
    
        // Validate email
        if (!userInputData?.email) {
            newErrors.email = "Email Address is required";
        // } 
        // else if (!isNaN(userInputData?.email) || /^-\d+$/.test(userInputData?.email)) {
        //     newErrors.email = "Email Address should not contain numeric or a negative integer";
        } else if (userInputData?.email.length < 2) {
            newErrors.email = "Email Address must contain at least 2 letters";
        }
    
        // Validate mobile
        const trimmedMobile = userInputData?.mobile?.trim();
        if (!trimmedMobile) {
            newErrors.mobile = "Mobile number is required";
        } else if (trimmedMobile.length !== 10) {
            newErrors.mobile = "Mobile number must be exactly 10 digits";
        } else if (specialCharacterPattern.test(trimmedMobile)) {
            newErrors.mobile = "Mobile number should not contain special characters";
        }
    
        // Validate password
        if (!userInputData?.password) {
            newErrors.password = "Password is required";
        } else if (userInputData?.password.length < 5) {
            newErrors.password = "Password must be at least 5 letters";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value)
    };

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    }

    const handleChange = (e) => {   
        const { name, value } = e.target;
        setUserInputData((prevState) => ( { ...prevState, [name] : value }));
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        if(validateForm()) {
            setIsAddBtnLoading(true);
            try {
                const headers = {
                    Authorization: `Bearer ${accessToken}`
                }
                const response = await axios.post("auth/user/create-outlet-user-account", userInputData, { headers });
                if (response?.data?.status === true) {
                        toast.success(response?.data?.data?.message, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                    getKioskOultetUsers();
                    setUserInputData({
                        name: "",
                        signupType: "",
                        mobile: "",
                        email: "",
                        outlet: "",
                        password: ""
                    });
                    setOpenAddModal(false);
                }
            } catch (error) {
                if (error?.response) {
                    let errorMessage = '';
                    if ( error.response?.status === 406 ) {
                        errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                    }
                    else if ( error.response?.status === 412 ) {
                        errorMessage = error?.response?.data?.data?.message;
                    } else if (error.response?.status === 500) {
                        errorMessage = error?.response?.data?.error
                    }
                    toast.error(errorMessage, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                }
            } finally {
                setIsAddBtnLoading(false);
            }
        }
    }

    const validateEditForm = () => {
        const newErrors = {};
        const trimmedTitle = editedUserData?.name.trim();
        const wordCount = trimmedTitle.split(/\s+/).length;
        const specialCharacterPattern = /[!@#$%^&*(),.?":{}|<>]/;
    
        // Validate name
        if (!editedUserData?.name) {
            newErrors.name = "Name is required";
        } else if (!isNaN(editedUserData?.name) || /^-\d+$/.test(editedUserData?.name)) {
            newErrors.name = "Name should not contain numeric or a negative integer";
        } else if (trimmedTitle.length < 2) {
            newErrors.name = "Name must contain at least 2 letters";
        } else if (specialCharacterPattern.test(editedUserData?.name)) {
            newErrors.name = "Name should not contain special characters";
        }
    
        // Validate email
        if (!editedUserData?.email) {
            newErrors.email = "Email Address is required";
        // } 
        // else if (!isNaN(editedUserData?.email) || /^-\d+$/.test(editedUserData?.email)) {
        //     newErrors.email = "Email Address should not contain numeric or a negative integer";
        } else if (editedUserData?.email.length < 2) {
            newErrors.email = "Email Address must contain at least 2 letters";
        }
    
        // Validate mobile
        const trimmedMobile = editedUserData?.mobile?.trim();
        if (!trimmedMobile) {
            newErrors.mobile = "Mobile number is required";
        } else if (trimmedMobile.length !== 10) {
            newErrors.mobile = "Mobile number must be exactly 10 digits";
        } else if (specialCharacterPattern.test(trimmedMobile)) {
            newErrors.mobile = "Mobile number should not contain special characters";
        }
    
        setEditErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleEditModal = (data) => {
        setOpenEditModal(true);
        setEditedUserData({
            _id: data?._id,
            name: data?.name,
            mobile: data?.mobile,
            email:  data?.email
        })
    }

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedUserData((prevState) => ({
            ...prevState,
            [name] : value
        }))
    }

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (validateEditForm()) {
            setIsEditBtnLoading(true);
            try {
                const headers = {
                    Authorization: `Bearer ${accessToken}`
                }
                const response = await axios.put("user/kiosk-outlet-user/profile", editedUserData, { headers });
                if (response?.data?.status === true) {
                    toast.success(response?.data?.data?.message, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                    getKioskOultetUsers();
                    setOpenEditModal(false);
                }
            } catch (error) {
                if (error?.response) {
                    let errorMessage = '';
                    if ( error.response?.status === 406 ) {
                        errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                    }
                    else if ( error.response?.status === 412 ) {
                        errorMessage = error?.response?.data?.data?.message;
                    } else if (error.response?.status === 500) {
                        errorMessage = error?.response?.data?.error
                    }
                    toast.error(errorMessage, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "colored",
                    });
                }
            } finally {
                setIsEditBtnLoading(false);
            }
        }
    }

    const handleDeleteModal = (data) => {
        setOpenDeleteModal(true);
        setKioskUserId(data?._id);
    }

    const handleDeleteKioskUser = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization : `Bearer ${accessToken}`
            }
            const data = {
                _id: kioskUserId
            }
            
            const response = await axios.delete("user/kiosk-outlet-user", { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
                });
                getKioskOultetUsers();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
                });
            }
        
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    }

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    }

    const handlePageChange = (page) => {
        setPage(page);
    };
  
    const handleRowsPerPageChange = (rowsPerPage) => {
        setPage(1);
        setRowsPerPage(rowsPerPage);
    };
  
    const getPaginatedData = () => {
        const startIndex = (page - 1) * rowsPerPage;
        
        const endIndex = startIndex + rowsPerPage;
  
        return filteredData?.slice(startIndex, endIndex);
    };

    useEffect(() => {
        getKioskOultetUsers();
        getOutletsData();
    }, []);

    useEffect(() => {
        const result = outletUserList.filter((item) => {
            return item?.name.toLowerCase().match(searchText.toLocaleLowerCase());
        });
        setFilteredData(result);
    }, [searchText]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold">KIOSK OUTLET USER MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>

                    <Row className='justify-content-between mt-2'>
                        <Col lg="4">
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="form-control"
                                    placeholder="Search for kiosk users..."
                                />
                                <button className="btn btn-primary" type="button">
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>
                        <Col lg="3" className="d-flex justify-content-end flex-column">
                            {(outletAccess.includes("KioskUser:add") || email === 'contact@xpansecafe.com') && (
                                <Button
                                    variant="primary"
                                    className="fw-semibold"
                                    onClick={handleOpenAddModal}
                                >
                                    <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                    Add New Kiosk User
                                </Button>
                            )}
                        </Col>
                    </Row>

                    <Row className='mt-3'>
                        <Col>
                            {(outletAccess?.includes("KioskUser:get") || email === 'contact@xpansecafe.com') && (
                                <ReusableTable
                                    columns={columns}
                                    data={getPaginatedData()}
                                    rowKey="serialNumber"
                                    loading={dataLoading}
                                    currentPage={page}
                                    recordsPerPage={rowsPerPage}
                                    onPageChange={handlePageChange}
                                    totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                                    onRecordsPerPageChange={handleRowsPerPageChange}
                                />
                            )}
                        </Col>
                    </Row>

                    {/* <---------------- Add Kiosk User Modal ---------------> */}
                    {openAddModal ? (
                        <Modal
                            show={openAddModal}
                            onHide={() => {
                                setOpenAddModal(false);
                                setErrors({});
                            }}
                            centered
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>ADD KIOSK OUTLET USER</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleSubmit}>
                                <Modal.Body>
                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Name <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Name"
                                                className="form-control"
                                                name="name"
                                                value={userInputData?.name}
                                                onChange={handleChange}
                                            />
                                            {errors.name && (
                                                <div className="text-danger" style={{ fontSize: "12px" }}>
                                                {errors.name}
                                                </div>
                                            )}
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Email <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Email"
                                                className="form-control"
                                                name="email"
                                                value={userInputData?.email}
                                                onChange={handleChange}
                                            />
                                            {errors.email && (
                                                <div className="text-danger" style={{ fontSize: "12px" }}>
                                                {errors.email}
                                                </div>
                                            )}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <div className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Mobile <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                min={1}
                                                minLength={10}
                                                type="number"
                                                placeholder="Mobile"
                                                className="form-control no-arrows"
                                                name="mobile"
                                                value={userInputData?.mobile}
                                                onChange={handleChange}
                                                onInput={(e) => {
                                                e.target.value = e.target.value
                                                    .replace(/[^0-9]/g, "")
                                                    .replace(/(\..*)\./g, "$1");
                                                }}
                                                pattern="^\d+(\.\d{1,2})?$"
                                                title="Mobile Number must be a whole number."
                                            />
                                            {errors.mobile && (
                                                <div className="text-danger" style={{ fontSize: "12px" }}>
                                                {errors.mobile}
                                                </div>
                                            )}
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-2">
                                            <Form.Group>
                                                <Form.Label className="fw-semibold">
                                                Select Outlet <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                className="w-100"
                                                id="outlet"
                                                name="outlet"
                                                value={userInputData?.outlet}
                                                onChange={handleChange}
                                                >
                                                <option value="" disabled>
                                                    Select Outlet
                                                </option>
                                                {outletsList?.map((outlets) => (
                                                    <option key={outlets._id} value={outlets._id}>
                                                    {outlets?.name}
                                                    </option>
                                                ))}
                                                </Form.Select>
                                            </Form.Group>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <div className="mb-2">
                                            <Form.Group>
                                                <Form.Label className="fw-semibold">
                                                Select SignUp Type <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                className="w-100"
                                                id="signupType"
                                                name="signupType"
                                                value={userInputData?.signupType}
                                                onChange={handleChange}
                                                >
                                                <option value="">Select Signup Type</option>
                                                <option value="REGULAR">REGULAR</option>
                                                {/* <option value="DEBIT">DEBIT</option> */}
                                                </Form.Select>
                                            </Form.Group>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Password <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Password"
                                                className="form-control"
                                                name="password"
                                                value={userInputData?.password}
                                                onChange={handleChange}
                                            />
                                            </div>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isAddBtnLoading}
                                    >
                                        { isAddBtnLoading ? <Spinner size='sm' /> : 
                                            "ADD OUTLET USER"
                                        }
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                    {/* <---------------- Edit Kiosk User Modal ---------------> */}
                    {openEditModal ? (
                        <Modal
                            show={openEditModal}
                            onHide={() => {
                            setOpenEditModal(false);
                            setEditErrors({});
                            }}
                            centered
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                            <Modal.Title>EDIT KIOSK OUTLET USER</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                            <Modal.Body>
                                <div className="mb-3">
                                <Form.Label className="fw-semibold">
                                    Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Name"
                                    className="form-control"
                                    name="name"
                                    value={editedUserData?.name}
                                    onChange={handleEditChange}
                                />
                                {editErrors.name && (
                                    <div className="text-danger" style={{ fontSize: "12px" }}>
                                    {editErrors.name}
                                    </div>
                                )}
                                </div>
                                <div className="mb-3">
                                <Form.Label className="fw-semibold">
                                    Mobile <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    min={1}
                                    minLength={10}
                                    type="number"
                                    placeholder="Mobile"
                                    className="form-control no-arrows"
                                    name="mobile"
                                    value={editedUserData?.mobile}
                                    onChange={handleEditChange}
                                    onInput={(e) => {
                                    e.target.value = e.target.value
                                        .replace(/[^0-9]/g, "")
                                        .replace(/(\..*)\./g, "$1");
                                    }}
                                    pattern="^\d+(\.\d{1,2})?$"
                                    title="Mobile Number must be a whole number."
                                />
                                {editErrors.mobile && (
                                    <div className="text-danger" style={{ fontSize: "12px" }}>
                                    {editErrors.mobile}
                                    </div>
                                )}
                                </div>
                                <div className="mb-3">
                                <Form.Label className="fw-semibold">
                                    Email <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Email"
                                    className="form-control"
                                    name="email"
                                    value={editedUserData?.email}
                                    onChange={handleEditChange}
                                />
                                {editErrors.email && (
                                    <div className="text-danger" style={{ fontSize: "12px" }}>
                                    {editErrors.email}
                                    </div>
                                )}
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={isEditBtnLoading}
                                >
                                {isEditBtnLoading ? <Spinner size='sm' /> : " Update Kiosk User" }
                                </Button>
                            </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                    {/* <---------------- Delete Outlet Modal ------------> */}
                    {openDeleteModal && (
                        <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirm Delete</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to delete this Kiosk user? This action cannot be undone.
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={handleDeleteKioskUser}>
                                    { isDeleteBtnLoading ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> :
                                        "Delete Outlet User"                                
                                    }
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

export default KioskOutletUsers